import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIStore } from '../types/store/UIStore';
import { MenuOptions } from '../types/ui';

const initialState: UIStore = {
  ...JSON.parse(localStorage.getItem("ui") || "{}"),
  language: localStorage.getItem('language') || 'pt',
};

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMenuOptions: (state, action: PayloadAction<MenuOptions[]>) => {
      state.currentMenuOptions = action.payload;
      state.currentMenu = action.payload && action.payload.length > 0;
    },
    clearMenuOptions: (state) => {
      state.selectedMenuOption = undefined;
      state.currentMenuOptions = [];
      state.currentMenu = false;
    },
    setSelectedMenuOption:  (state, action: PayloadAction<MenuOptions>) => {
      state.selectedMenuOption = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
  },
});

export const { setLoading, setMenuOptions, clearMenuOptions, setSelectedMenuOption, setLanguage } = ui.actions;
export default ui.reducer;
